<i
    class="shrink-0 text-[27px]"
    [ngClass]="[icon() ?? 'animated-arrow-right', inverted() ? 'text-white' : 'text-accent']"
    aria-hidden="true"
></i>
<span
    class="font-headline text-16 flex-1 leading-20 group-hover:underline"
    [ngClass]="[inverted() ? 'text-white' : 'text-accent', alignCenter() ? 'text-center' : 'text-left']"
>
    <ng-content />
</span>
